<template>
  <div
      class="mguu-alert"
      v-if="alertMguuStore.isShowAlertMguu"
  >
    <div class="mguu-alert__ok">
      <info-icon />
    </div>
    <div class="mguu-alert__block">
      {{ alertMguuStore.showAlertMguuTextMessage }}
    </div>
    <div class="mguu-alert__close">
      <button class="close-btn" @click="Close()">
      <img
          src="@/assets/img/svg/close.svg"
      />
      </button>
    </div>
  </div>
</template>

<script>

import useAlertMguuStore from "@/store/alertmguu.store.ts";
import InfoIcon from "@/components/icons/InfoIcon.vue";

export default {
  name: "AppAlertMguu",
  components: { InfoIcon },
  setup() {
    const alertMguuStore = useAlertMguuStore();

    return {
      alertMguuStore
    }
  },

  methods: {
    Close() {
      this.alertMguuStore.showAlertMguuTextMessage = '';
      this.alertMguuStore.isShowAlertMguu = false;
    }
  }



}
</script>

<style lang="scss" src="./AppAlertMguu.scss"/>